import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { observable, computed } from 'mobx';


@Injectable({ providedIn: 'root' })
export class BusyService {
    private isBusySubscribers = observable<isBusyValue>([]);

    public isBusy = computed(() => this.isBusySubscribers.length > 0);

    constructor(private toastr: ToastrService) { }

    set(value: isBusyValue) {
        const idx = this.isBusySubscribers.map(e => e.key).indexOf(value.key);

        if (value.isBusy === true && idx < 0) {
            if (value.message) {
                value.toast = this.toastr.info(value.message, '', { timeOut: 0, extendedTimeOut: 0 });
            }
            this.isBusySubscribers.push(value);
        } else if (value.isBusy === false && idx >= 0) {
            const existing = this.isBusySubscribers[idx];
            if (existing.toast) {
                this.toastr.clear(existing.toast);
            }
            this.isBusySubscribers.splice(idx, 1);
        }
    }
}
